import { Components as MUIComponents, Theme } from "@mui/material";
import { FacTextFieldTheme } from "./FacTextField";
import { ButtonTheme } from "./Button";
import PaperTheme from "./Paper/Paper.theme";

export const Components: MUIComponents<Omit<Theme, "components">> | undefined = {
    ...FacTextFieldTheme,
    ...ButtonTheme,
    ...PaperTheme,
};

export default Components;

